// import GoogleLogin from 'react-google-login';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom'
// import { useAuth } from './useAuth';
// import SCTlogo from "../../assets/images/effikit-logo.png"

// const Login = ({setLogin}: {setLogin: any}) => {

//     const history = useNavigate()
//     const { signin, isAuthenticated } = useAuth()
//     const location = useLocation()

//     let from: any;
//     if (location.state) {
//         from = location.state
//     } else {
//         from = { pathname: '/task' }
//     }
//     const responseGoogle = async (response: any) => {
//         const resp = await axios({
//             method: "POST",
//             url: process.env.REACT_APP_API_URL + '/auth/login',
//             data: { tokenId: response.tokenId }
//         })
//         const { access_token } = resp.data?.data

//         if (access_token) {
//             if (from) {
//                 signin(access_token, () => history(from))
//                 setLogin(isAuthenticated())
//             }
//         }
//     }

//     let clientId = process.env.REACT_APP_GOOGLE_LOGIN_CLIENTID

//     return (
//             <div className='login-middle-card'>
//                 <div className="card login-card">
//                     <div className="login-card-welcome text-center">
//                         <div className='d-flex login-logo'>
//                             <img src={SCTlogo} alt='logo' />
//                         </div>
//                     <h1>Welcome</h1>
//                         <p> Complete management tool for Organization </p>
//                     </div>
//                     <div className="login-card-action">
//                         {clientId ? <div className='login-field'>
//                                 <GoogleLogin
//                                     clientId={clientId}
//                                     buttonText="Login with Google"
//                                     hostedDomain={process.env.REACT_APP_LOGIN_DOMAIN}
//                                     onSuccess={responseGoogle}
//                                     onFailure={responseGoogle}
//                                     cookiePolicy={'single_host_origin'}
//                                 />
//                             </div> : ''}
//                     </div>
//                 </div>
//                 <p> By clicking “Login with Google” above, you acknowledge that you have read and understood, and agree to  <a href="#"> Terms & Conditions </a> and <a href="#"> Privacy Policy. </a> </p>
//         </div>
//     )
// }

// export default Login

import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import SCTlogo from "../../assets/images/effikit-logo.png";
import { Toast } from "primereact/toast";
import jwtDecode from "jwt-decode";

const Login = ({ setLogin }: { setLogin: any }) => {
  const navigate = useNavigate();
  const { signin, isAuthenticated } = useAuth();
  const myToast = useRef<Toast>(null);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMasked, setIsMasked] = useState(true);
  const inputsRef: any = useRef([]);

  useEffect(() => {
    // Redirect user if already authenticated
    if (localStorage.getItem("isAuthenticated") === "true") {
      navigate("/task");
    }
    const handleStorageChange = (e: any) => {
      if (e.key === "isAuthenticated" && e.newValue === "true") {
        navigate("/task");
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current?.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const isSendOtpDisabled =
    !email ||
    !email.endsWith("@solutionchamps.com") ||
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // if (!email || !email.endsWith("@solutionchamps.com")) {
  //   showToast("warn", "Warning", "Please fill in the  email field");
  // }

  const sendOTP = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (isSendOtpDisabled) {
      showToast("error", "Error", "Please enter your email address.");
      return;
    } else if (!emailRegex.test(email)) {
      showToast("error", "Error", "Please enter a valid email address.");
      return;
    }
    setLoading(true);
    setIsButtonDisabled(true);
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/outlook-login`,
        { email }
      );
      if (resp.data.success) {
        setIsOTPSent(true);
        showToast(
          "success",
          "Success",
          "OTP sent successfully. Please check your email."
        );
      } else {
        showToast(
          "warn",
          "Warning",
          resp?.data?.message ||
            resp?.data?.data?.message ||
            "Failed to send OTP. Please try again."
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        error?.response?.data?.data?.message ||
        "Failed to send OTP. Please try again.";
      showToast("error", "Error", errorMessage);
    } finally {
      setLoading(false);
      setIsButtonDisabled(false);
    }
  };

  const verifyOTP = async () => {
    if (otp.some((digit) => digit === "")) {
      showToast("warn", "Warning", "Please enter the OTP to login.");
      return;
    }
    setLoading(true);
    setIsButtonDisabled(true);
    try {
      const otpCode = otp.join("");
      const resp = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify`,
        {
          email,
          otp: parseInt(otpCode),
        }
      );

      const tokens = resp?.data?.tokens || resp?.data?.data?.tokens;

      if (tokens && tokens.access_token) {
        const { access_token } = tokens;

      // Decode token to extract the user ID
      const decodedToken:any = jwtDecode(access_token);
      const employeeId = decodedToken?.data?._id;
      const userId=decodedToken?.data?.profile?._id;
      const currentUserRole=decodedToken?.data?.role;

      // Store employeeId in localStorage
      if (employeeId) {
        localStorage.setItem("employeeId", employeeId);
        localStorage.setItem("currentUserRole",currentUserRole);
        localStorage.setItem("userId",userId)
      }

        signin(access_token, () => {
          localStorage.setItem("isAuthenticated", "true");
          navigate("/task");
          setLogin(isAuthenticated());
          console.log('success!')
          showToast("success", "Success", "OTP verification successful.");
          // Refresh the page after navigation
          window.location.reload();
        });
      } else {
        showToast(
          "warn",
          "Warning",
          resp?.data?.message ||
            resp?.data?.data?.message ||
            "Incorrect OTP. Please try again."
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      showToast("error", "Error", "Incorrect OTP. Please try again.");
    } finally {
      setLoading(false);
      setIsButtonDisabled(false);
    }
  };

  const handleOtpChange = (e: any, index: any) => {
    const value = e.target.value.slice(0, 1);
    if (/^[0-9]*$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < otp.length - 1) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").slice(0, 6); 
    const newOtp = [...otp];

    for (let i = 0; i < pastedData.length; i++) {
      if (i < newOtp.length && /^[0-9]*$/.test(pastedData[i])) {
        newOtp[i] = pastedData[i]; 
      }
    }

    setOtp(newOtp);

    const nextEmptyIndex = newOtp.findIndex((digit) => digit === "");
    if (nextEmptyIndex !== -1 && inputsRef.current[nextEmptyIndex]) {
      inputsRef.current[nextEmptyIndex].focus();
    } else {
      inputsRef.current[5]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      for (let i = otp.length - 1; i >= 0; i--) {
        if (newOtp[i] !== "") {
          newOtp[i] = "";
          setOtp(newOtp);
          inputsRef.current[i].focus(); 
          e.preventDefault(); 
          return; 
        }
      }

      inputsRef.current[0].focus();
      e.preventDefault(); 
    }
  };

  const handleCancel = () => {
    if (!isOTPSent) {
      // Clear the email input field
      setEmail("");
    } else {
      // Reset back to email input
      setIsOTPSent(false);
      setEmail("");
      setOtp(["", "", "", "", "", ""]); // Clear OTP fields
    }
  };

  const toggleMasking = () => {
    setIsMasked((prev) => !prev); 
  };

  return (
    <div className="login-middle-card">
      <Toast ref={myToast} />
      <div className="card login-card">
        <div className="login-card-welcome text-center">
          <div className="d-flex login-logo">
            <img src={SCTlogo} alt="logo" />
          </div>
          <h1>{!isOTPSent ? "Login" : "OTP Verification"}</h1>
          <p>Complete management tool for Organization</p>

          {!isOTPSent ? (
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          ) : (
            <div className="enter-otp">
              {otp.map((_, index) => (
                <input
                  key={index}
                  type={isMasked ? "password" : "text"}
                  value={otp[index]}
                  onChange={(e) => handleOtpChange(e, index)}
                  onPaste={handleOtpPaste}
                  onFocus={toggleMasking}
                  onBlur={toggleMasking}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputsRef.current[index] = el)}
                  maxLength={1}
                  pattern="[0-9]*"
                  required
                  className="form-control"
                />
              ))}
            </div>
          )}
        </div>
        <div className="login-card-action">
          {isOTPSent && (
            <div className="btm-actions">
              <button className="btn cancel" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          )}

          <div className="tsk-btn">
            <button
              className="d-flex btn add-time"
              onClick={!isOTPSent ? sendOTP : verifyOTP}
              disabled={
                isButtonDisabled || loading || (!isOTPSent && isSendOtpDisabled)
              }
            >
              {loading
                ? !isOTPSent
                  ? "Sending..."
                  : "Verifying..."
                : !isOTPSent
                ? "Send OTP"
                : "Verify OTP"}
            </button>
          </div>
        </div>
      </div>
      {!isOTPSent && (
        <p>
          By clicking 'Send OTP' above, you acknowledge that you have read,
          understood, and agree to the <a href="#"> Terms & Conditions </a> and{" "}
          <a href="#"> Privacy Policy. </a>
        </p>
      )}
    </div>
  );
};

export default Login;
